import { render, staticRenderFns } from "./sidenavigation.vue?vue&type=template&id=1484e092&scoped=true"
import script from "./sidenavigation.vue?vue&type=script&lang=ts"
export * from "./sidenavigation.vue?vue&type=script&lang=ts"
import style0 from "./sidenavigation.vue?vue&type=style&index=0&id=1484e092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1484e092",
  null
  
)

export default component.exports